{
  "/ajax/get_layout_v2": true,
  "/ajax/rank_dynamic_slots": true
}